/*
 * @Description: 
 * @Author: Mankeung
 * @Date: 2021-07-10 15:15:33
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-27 13:44:39
 */
export default [

  {
    path: "complaintList",
    name: "COMPLAINT_LIST",
    meta: {
      title: "投诉列表",
      icon: "",
      isNav: true,
    },
    component: () =>
      import("@/views/complaint/complaintList.vue"),
  },

];